/**
* Send dom id content to print dialog...
*/
window.printContent = function (el) {
    var getFullContent = document.body.innerHTML;
    var printsection = document.getElementById(el).innerHTML;
    document.body.innerHTML = printsection;
    window.print();
    document.body.innerHTML = getFullContent;
}

/**
* Return random text...
*/
window.randomText = function (options) {

	if (typeof (options) === "undefined") {
		var options = { length: 12, ucase: true, lcase: true, digits: true, symbols: true };
	}
	var chars = "";
	var _charsV = { alpha: "abcdefghijklmnopqrstuvwxyz", ALPHA: "ABCDEFGHIJKLMNOPQRSTUVWXYZ", digits: "1234567890", symbols: "&!@#%?/$" };
	if (options.ucase) {
		chars = chars + _charsV.ALPHA + (options.symbols ? _charsV.symbols : "");
	}
	if (options.lcase) {
		chars = chars + _charsV.alpha + (options.symbols ? _charsV.symbols : "");
	}
	if (options.digits) {
		chars = chars + _charsV.digits + (options.symbols ? _charsV.symbols : "");
	}

	var randtext = "";
	for (var i = 0, n = chars.length; i < options.length; i++) {
		randtext += chars.charAt(Math.floor(Math.random() * n));
	}
	return randtext;
}

/**
 * Returns the function that you want to execute through its name.
 * It returns undefined if the function || property doesn't exists
 *
 * @param functionName {String}
 * @param context {Object || null}
 */
window.getFunctionByName = function (functionName, context) {
	// If using Node.js, the context will be an empty object
	if (typeof (window) == "undefined") {
		context = context || global;
	} else {
		// Use the window (from browser) as context if none providen.
		context = context || window;
	}

	// Retrieve the namespaces of the function you want to execute
	// e.g Namespaces of "MyLib.UI.alerti" would be ["MyLib","UI"]
	var namespaces = functionName.split(".");

	// Retrieve the real name of the function i.e alerti
	var functionToExecute = namespaces.pop();

	// Iterate through every namespace to access the one that has the function
	// you want to execute. For example with the alert fn "MyLib.UI.SomeSub.alert"
	// Loop until context will be equal to SomeSub
	for (var i = 0; i < namespaces.length; i++) {
		context = context[namespaces[i]];
	}

	// If the context really exists (namespaces), return the function or property
	if (context) {
		return context[functionToExecute];
	} else {
		return undefined;
	}
}